module.exports = __webpack_public_path__ + "static/media/S4C_THUMBNAIL.bc3a1091.png";